"use client";
import { jsx as n, jsxs as z } from "react/jsx-runtime";
import { forwardRef as B, useContext as g, useMemo as y } from "react";
import { splitResponsiveVariant as N, css as S, cx as j } from "@/styled-system/css";
import { ButtonGroupContext as k } from "../button-group/button-group.context.js";
import { ButtonLoading as w } from "./button-loading.js";
import { ButtonRootContext as G } from "./context/button-root.context.js";
import { buttonRecipe as I } from "./styles/button-root.styles.js";
import { Slottable as P, Slot as D } from "../../node_modules/.pnpm/@radix-ui_react-slot@1.1.0_@types_react@18.3.16_react@18.3.1/node_modules/@radix-ui/react-slot/dist/index.js";
const F = B(
  (d, m) => {
    const o = g(k), {
      asChild: s = !1,
      tone: i = "brand",
      emphasis: a = "outlined",
      children: p,
      className: c,
      css: u,
      disabled: e = !1,
      fluid: f = o.fluid || !1,
      onImpact: r = !1,
      size: l = o.size || "md",
      loading: t = !1,
      onClick: b,
      ...h
    } = d, x = N("fluid", f), C = S(
      I.raw({
        tone: o.tone || i,
        emphasis: o.emphasis || a,
        disabled: e || t,
        onImpact: r,
        loading: t,
        size: o.size || l,
        ...x
      }),
      u
    ), R = s ? D : "button", v = y(
      () => ({
        ...s && (e || t) ? {
          "aria-disabled": !0,
          tabIndex: -1
        } : {
          disabled: e || t
        }
      }),
      [s, e, t]
    );
    return /* @__PURE__ */ n(
      G.Provider,
      {
        value: {
          tone: o.tone || i,
          emphasis: o.emphasis || a,
          disabled: t,
          onImpact: r,
          size: o.size || l,
          loading: t
        },
        children: /* @__PURE__ */ z(
          R,
          {
            ref: m,
            "data-c11n-component": "Button.Root",
            "data-c11n-version": "10.0.0-alpha.19",
            className: j("c11n", "group", C, c),
            onClick: e ? void 0 : b,
            ...v,
            ...h,
            children: [
              /* @__PURE__ */ n(P, { children: p }),
              t ? /* @__PURE__ */ n(w, {}) : null
            ]
          }
        )
      }
    );
  }
);
F.displayName = "Button.Root";
export {
  F as ButtonRoot
};
//# sourceMappingURL=button-root.js.map
